import { FormWrapperLabel, useTranslation } from '@ukpostbox/frontend-framework';
import { GetPagedArrayIndexByKeyValue } from '@ukpostbox/helpers';
import { useInfiniteTags } from '@ukpostbox/client-data';
import { Controller } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect, useRef } from 'react';
import AddTagControlMinimal from '../../../../_Global/Components/Tags/AddTagControlMinimal';
import { SearchTypesType } from '../SearchControlTypes';

function SearchMailTags(props: SearchTypesType) {
	const { t } = useTranslation();
	const { data, status, error } = useInfiniteTags();

	const inputRef = useRef<HTMLInputElement | null>(null);

	useEffect(() => {
		if (inputRef.current) {
			inputRef.current.value = props.searchParams?.get('mailTagIds')
				? (props.searchParams.get('mailTagIds') as string)
				: '';
		}
	}, [props.searchParams]);

	return (
		<Controller
			name='mailTagIds'
			control={props.formMethods.control}
			render={({ field, fieldState }) => (
				<FormWrapperLabel
					label={t('mailboxes.filter.labels.tags')}
					invalid={fieldState.invalid}
					validationMessage={fieldState.error?.message}
				>
					<AddTagControlMinimal
						name='mailTagIds'
						existingTags={
							props.searchParams?.get('mailTagIds')
								? [parseInt(props.searchParams?.get('mailTagIds') as string, 10)]
								: undefined
						}
						updateCallback={(e: Array<any>) => {
							field.onChange(e);

							let label = t('mailboxes.filter.counts.tags', { count: e.length });

							if (e.length === 1 && data) {
								const indexes = GetPagedArrayIndexByKeyValue(data as any, 'id', e[0]);
								label = indexes
									? `${t('labels.tag')}: ${data?.pages[indexes?.pageIndex].data[indexes?.itemIndex].name}`
									: label;
							}
						}}
					/>
				</FormWrapperLabel>
			)}
		/>
	);
}

export { SearchMailTags };
